import { styles } from "../style";
import { projects } from "../constant";
import { motion } from "framer-motion";
import { fadeIn, textVariant } from "../utils/motion";
import { SectionWrapper } from "../hoc";
import { Tilt } from "react-tilt";

const ProjectCard = ({ item, name, description, tags, image, link }) => {
    return (
        <motion.div variants={fadeIn("up", "spring", 0.5 * item, 0.75)}>
            <Tilt
                options={{
                    max: 45,
                    scale: 1,
                    speed: 450,
                }}
                className="bg-tertiary p-5 rounded-2xl sm:w-[360px] w-full cursor-pointer"
            >
                <div onClick={() => window.open(link, "_blank")} key={name} >
                    <img className="w-full h-36 object-contain rounded-2xl" src={image} alt='project_image' />
                    <h3 className="text-white text-[20px] font-bold text-center mt-4">{name}</h3>
                    <p className="text-secondary text-[16px] md:text-[14px] my-4 max-w-3xl leading-[30px]">{description}</p>

                            <div className='mt-4 flex flex-wrap gap-2'>
                        {tags.map((tag) => (
                                    <p key={tag.name} className={`text-[14px] ${tag.color}`}>#{tag.name}</p>
                                ))}
                            </div>

                        </div>
            </Tilt>
        </motion.div>
    )
}

const Portfolio = () => {
    return (
        <>
            <motion.div variants={textVariant()}>
                <p className={`${styles.sectionSubText} `}>My Projects</p>
                <h2 className={`${styles.sectionHeadText}`}>Overview.</h2>
            </motion.div>

            <div className='w-full flex'>
                <motion.p
                    variants={fadeIn("", "", 0.1, 1)}
                    className='mt-3 text-secondary text-[17px] max-w-3xl leading-[30px]'
                >
                    Below projects showcases my work and experience in building a real world applications.
                    Each work is briefly describe with links to code repository and demo links.
                    The projects reflect my ability to work with different technologies without compromising quality in my work.
                </motion.p>
            </div>

            <div className="mt-20 flex flex-wrap gap-7">
                {
                    projects.map((project, item) => (
                        <ProjectCard key={`project-${item}`}
                            item={item}
                            {...project}
                        />
                    ))
                }
            </div>
        </>
    );
}

export default SectionWrapper(Portfolio, "portfolio")